const globalStyleId = 'gs-text-main';
const defaultSelector = {
  selector: '#{mID} .gf_product-title',
};
export default {
  defaultClass: 'gf_gs-text-heading-3',
  settingGroups: {
    [globalStyleId]: {
      fontWeight: {
        ...defaultSelector,
        inherit: 'text.fontWeight',
        cssAttr: 'font-weight',
      },
      'font-size': {
        ...defaultSelector,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
      'line-height': {
        ...defaultSelector,
        inherit: 'text.lineHeight',
        cssAttr: 'line-height',
        listUnit: 'em',
      },
      'letter-spacing': {
        ...defaultSelector,
        inherit: 'text.letterSpacing',
        cssAttr: 'letter-spacing',
        listUnit: 'px',
      },
      // "color": {
      //   ...defaultSelector,
      //   inherit: "text.fontColor",
      //   cssAttr: "color"
      // },
      font: {
        ...defaultSelector,
        inherit: 'text.fontFamily',
        cssAttr: 'font-family',
      },
    },
  },
};

export const P_TITLE_SETTING = [
  {
    gsId: globalStyleId,
    gsSettingGroup: 'Typography',
    isRenderColumn: false,
    prefix: 'gf_gs-text-',
    typeSetting: 'heading-paragraph',
  },
];
